module.exports = __webpack_public_path__ + "static/media/solar-system-with-metheor.png";